'use client';
import React from 'react';
import { AlertTriangle, X } from 'lucide-react';

interface ConfirmModalProps {
  isOpen: boolean;
  title: string;
  description: string;
  confirmLabel: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
  variant?: 'danger' | 'warning';
}

export default function ConfirmModal({
  isOpen,
  title,
  description,
  confirmLabel,
  cancelLabel = 'Cancel',
  onConfirm,
  onCancel,
  variant = 'danger',
}: ConfirmModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 animate-fade-in">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onCancel} />
      <div className="relative bg-[#111111] border border-[#2A2A2A] rounded-xl p-6 w-full max-w-md shadow-modal animate-slide-up">
        <button
          onClick={onCancel}
          className="absolute top-4 right-4 text-[#555] hover:text-white transition-colors"
        >
          <X size={18} />
        </button>
        <div className={`w-10 h-10 rounded-full flex items-center justify-center mb-4 ${variant === 'danger' ? 'bg-red-500/15' : 'bg-amber-500/15'}`}>
          <AlertTriangle size={20} className={variant === 'danger' ? 'text-red-400' : 'text-amber-400'} />
        </div>
        <h3 className="text-white font-700 text-lg mb-2">{title}</h3>
        <p className="text-[#888] text-sm mb-6 leading-relaxed">{description}</p>
        <div className="flex gap-3">
          <button onClick={onCancel} className="flex-1 leverage-btn-secondary text-sm py-2.5">
            {cancelLabel}
          </button>
          <button
            onClick={onConfirm}
            className={`flex-1 rounded-lg px-4 py-2.5 text-sm font-600 transition-all duration-150 active:scale-95 ${
              variant === 'danger' ?'bg-red-600 hover:bg-red-500 text-white' :'bg-amber-500 hover:bg-amber-400 text-black'
            }`}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}